<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入关键词" v-model="name"  style="width:300px;" @change="getData">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>

        <!-- 商品列表 -->
        <div class="content">
            <el-table :data="tableData"  height="630" style="width: 100%">
                <el-table-column  prop="name" label="搜索词" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  prop="num" label="搜索次数" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  prop="language" label="搜索来源" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.language == 'zh'">中文</span>
                        <span v-if="scope.row.language == 'en'">英文</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="loadPage" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </div>
    </section>
</template>



<script>
import { search_list } from '@/api/summary.js'

export default {
    data() {
        return {
            name:'',
            page:1,
            total:0,
            size: 0,
            tableData:[],
        }
    },
    methods: {
        search() {
            this.page = 1;
            this.getData()
        },
        getData(){
            let params = {
                page:this.page
            }
            if(this.name != ""){
                params.name = this.name
            }
            search_list(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size = res.data.per_page
                }
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
    },
    created(){
        this.getData()
    }
}
</script>

<style lang="less" scoped>
// .section{

// }
</style>


